<template>
  <div>
    <div class="flex-container-line px-12 py-12">
      <span class="font-16 fw-500">Tin nhắn</span>
      <el-select
        v-model="selectAccountId"
        filterable
        default-first-option
        placeholder="Tất cả tài khoản"
        size="small"
        collapse-tags
        multiple
        clearable
        style="width: 200px"
        @change="removeFilter">
        <el-input
          ref="search1"
          class="px-12 py-1"
          size="small"
          v-model="accountSearch"
          placeholder="Tìm kiếm tài khoản..."
          clearable
          @input="onChangeAccountSearch">
          <IconV2
            slot="prefix"
            class="my-12 ms-3"
            name="v2-search" />
        </el-input>
        <div
          class="d-flex align-items-center account-all pointer font-14"
          @click="onSelectAll">
          <span
            :class="selectAllAccount && 'account-all-active'"
            style="width: 132px">
            Tất cả tài khoản
          </span>
          <IconV2
            v-if="selectAllAccount"
            class="ms-2"
            name="v2-check"
            color="#0A58C0"
            size="0.75rem" />
        </div>

        <el-divider class="my-0" />

        <div
          v-for="account in accountsFilter"
          :key="account.accountId"
          class="d-flex align-items-center account-all pointer font-14"
          @click="onSelectAccount(account.accountId)">
          <span
            class="trim-text-1-line"
            :class="selectAccountId.includes(account.accountId) && 'account-all-active'"
            style="max-width: 200px">
            {{ account.name }}
          </span>
          <IconV2
            v-if="selectAccountId.includes(account.accountId)"
            class="ms-2"
            name="v2-check"
            color="#0A58C0"
            size="0.75rem" />
        </div>

        <el-option
          v-show="false"
          v-for="(account, index) in accounts"
          :key="index"
          :label="getAccountName(account).length < 15 ? getAccountName(account) : getAccountName(account).slice(0, 14) + '...'"
          :value="account.accountId"></el-option>
        <!-- 
        <div
          slot="empty"
          style="margin-top: 6px">
          <div
            class="d-flex align-items-center account-all pointer font-14"
            @click="onSelectAll">
            <span
              :class="selectAllAccount && 'account-all-active'"
              style="width: 132px">
              Tất cả tài khoản
            </span>
            <IconV2
              v-if="selectAllAccount"
              class="ms-2"
              name="v2-check"
              color="#0A58C0"
              size="0.75rem" />
          </div>
          <el-input
            ref="search2"
            autofocus
            class="input-single px-1"
            size="small"
            v-model="accountSearch"
            placeholder="Tìm kiếm tài khoản..."
            clearable
            @input="onChangeAccountSearch"></el-input>
          <el-divider class="my-0" />
        </div> -->
      </el-select>

      <!-- <el-dialog
        width="700px"
        title="Tìm kiếm liên hệ"
        :visible.sync="searchNewContactVisible"
        :close-on-click-modal="false"
        destroy-on-close>
        <div slot="title"></div>
        <SearchNewContact />
      </el-dialog> -->

      <DialogSearchContact
        v-if="searchNewContactVisible"
        @close="searchNewContactVisible = false" />
    </div>
    <el-divider class="mt-0 mb-2" />
    <div class="flex-container-line px-12 pb-2 pt-1">
      <el-input
        size="small"
        ref="inputMesage"
        @input="searchKeyChanged"
        v-model="inputSearchKey"
        placeholder="Tìm kiếm">
        <template #suffix>
          <div class="d-flex align-items-center">
            <el-tooltip
              effect="dark"
              content="Thêm liên hệ"
              placement="top">
              <div
                class="z2-btn z2-btn-small mt-1"
                @click="searchNewContact()">
                <img
                  class="font-16"
                  src="/assets/icon/add_contact_icon.svg" />
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="Tham gia nhóm"
              placement="top">
              <div
                class="z2-btn z2-btn-small mt-1 ms-1"
                @click="searchGroup()">
                <IconV2
                  name="v2-group-add"
                  color="#73AFFF" />
              </div>
            </el-tooltip>
          </div>
        </template>
        <img
          slot="prefix"
          src="/assets/icon/icon_search.svg"
          class="mt-2 ms-1" />
      </el-input>

      <DialogSearchGroupByLink
        v-if="dialogSearchGroup"
        @close="dialogSearchGroup = false" />

      <DialogLinkGroupInfo
        v-if="dialogLinkGroupInfo"
        :accountId="dataLinkGroupInfo.conversation.accountId"
        :link="dataLinkGroupInfo.link"
        @close="onCloseDialogLinkGroupInfo" />
    </div>
    <div class="d-flex m-body align-items-center mb-1">
      <el-button
        class="btn-tab w-50"
        plain
        :class="searchTab === 'contact' ? 'btn-active' : ''"
        @click="$emit('updateSearchTab', 'contact'), (filter.searchKey = inputSearchKey)">
        Liên hệ
      </el-button>
      <el-button
        class="btn-tab w-50"
        plain
        :class="searchTab === 'message' ? 'btn-active' : ''"
        @click="$emit('updateSearchTab', 'message'), (filterMessage.searchKey = inputSearchKey)">
        Tin nhắn
      </el-button>
      <div
        v-if="searchTab === 'message'"
        class="mx-2 pointer"
        @click="resetFilterSearch">
        <IconV2
          name="v2-close-circle"
          size="20px"
          color="#CF4547" />
      </div>
    </div>
    <div
      v-if="searchTab === 'contact'"
      class="flex-container-line px-12 pb-1 border-bottom">
      <div class="d-flex justify-content-between">
        <div
          v-for="item in filterMessages"
          :key="item.key"
          class="rounded z2-button-filter"
          :class="filter.filterMessage == item.text && 'z2-button-filter-active'"
          @click="selectFilterMessage(item.text)">
          <el-tooltip
            effect="dark"
            :content="item.text"
            placement="top">
            <IconV2
              :name="item.src"
              size="x-lg" />
          </el-tooltip>
        </div>
        <div
          class="rounded z2-button-filter"
          :class="filter.filterGroup == item.text && 'z2-button-filter-active'"
          v-for="item in filterGroups"
          :key="item.key"
          @click="selectFilterGroup(item.text)">
          <el-tooltip
            effect="dark"
            :content="item.text"
            placement="top">
            <IconV2
              :name="item.src"
              size="x-lg" />
          </el-tooltip>
        </div>
        <div
          class="z2-button-filter rounded"
          :class="filterEnabledTag && 'z2-button-filter-active'">
          <el-popover
            placement="bottom"
            trigger="click">
            <div class="conversation-box-popover">
              <div class="mb-3 font-size-16 d-flex">
                <div class="flex-grow-1">Lọc theo tag</div>
                <el-tooltip
                  class="item pointer mx-1"
                  effect="dark"
                  content="Xóa bộ lọc"
                  placement="top"
                  v-if="filterEnabledTag">
                  <i
                    class="icon-close-fill text-danger item fw-bold font-size-16 mx-1"
                    @click="clearTag" />
                </el-tooltip>
              </div>
              <div
                class="d-flex flex-wrap text-center overflow-auto"
                style="max-width: 400px; max-height: 300px">
                <el-input v-model="searchTag" placeholder="Tìm tên thẻ" clearable class="mb-2" />
                <div
                  v-for="(tag, index) in filterTags"
                  :key="index">
                  <div
                    class="d-flex pointer"
                    @click="selectTag(tag.id)">
                    <div style="margin: 2px">
                      <TagV2
                        :data="tag"
                        :inactive="!selectedTag(tag.id)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <el-tooltip
              slot="reference"
              effect="dark"
              content="Lọc theo tag"
              placement="top">
              <IconV2
                name="v2-tag1"
                size="x-lg" />
            </el-tooltip>
          </el-popover>
        </div>
        <div
          class="z2-button-filter rounded"
          :class="filterEnableCalender && 'z2-button-filter-active'">
          <el-popover
            placement="bottom"
            trigger="click">
            <div>
              <el-date-picker
                v-model="filter.dateRange"
                size="small"
                type="daterange"
                range-separator="-"
                start-placeholder="Ngày bắt đầu"
                end-placeholder="Ngày kết thúc"
                :default-time="['00:00:00', '23:59:59']"></el-date-picker>
            </div>
            <el-tooltip
              slot="reference"
              class="item mx-1 pointer d-flex justify-content-center align-items-center"
              effect="dark"
              content="Lọc theo thời gian"
              placement="top">
              <IconV2
                name="v2-date"
                size="x-lg" />
            </el-tooltip>
          </el-popover>
        </div>
      </div>
      <div class="flex-1 p-1 mx-1 pointer d-flex align-items-center justify-content-end">
        <el-tooltip
          slot="reference"
          effect="dark"
          content="Xóa bộ lọc"
          placement="top">
          <img
            v-if="!filterEnabled"
            class="font-icon-18"
            src="/assets/icon/icon-remove-filter-v2.svg" />
          <img
            v-else
            @click="removeFilter()"
            class="font-icon-18"
            src="/assets/icon/icon-remove-filter-active-v2.svg" />
        </el-tooltip>
      </div>
    </div>
    <div
      v-else
      class="flex-container-line px-1 pb-1 border-bottom">
      <el-select
        style="min-width: 145px"
        v-model="filterMessage.conversationType"
        default-first-option
        placeholder="Tất cả tin nhắn"
        size="small"
        collapse-tags>
        <IconV2
          class="mt-2 ms-1"
          slot="prefix"
          name="v2-user" />
        <el-option
          label="Tất cả tin nhắn"
          key="all"
          value="all"></el-option>
        <el-option
          label="Cá nhân"
          key="user"
          value="user"></el-option>
        <el-option
          label="Nhóm"
          key="group"
          value="group"></el-option>
      </el-select>
      <el-popover
        placement="bottom"
        trigger="click">
        <div>
          <el-date-picker
            v-model="filterMessage.dateRange"
            size="small"
            type="daterange"
            range-separator="-"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc"
            :default-time="['00:00:00', '23:59:59']"
            @change="updateDateRangeValue"></el-date-picker>
        </div>
        <el-tooltip
          slot="reference"
          class="item pointer d-flex justify-content-center align-items-center"
          effect="dark"
          content="Lọc theo thời gian"
          placement="top">
          <el-input
            class="ms-1 pointer"
            style="min-width: 130px"
            :value="filterMessage.dateRangeValue || 'Tất cả thời gian'"
            placeholder="Tất cả thời gian"
            readonly
            size="small">
            <IconV2
              class="mt-2 ms-1"
              slot="prefix"
              name="v2-date" />
          </el-input>
        </el-tooltip>
      </el-popover>
    </div>
  </div>
</template>

<script>
import TagV2 from "@/components/TagV2";
import IconV2 from "./common/IconV2.vue";
import DialogSearchContact from "./contact/DialogSearchContact.vue";
import DialogSearchGroupByLink from "./contact/DialogSearchGroupByLink.vue";
import DialogLinkGroupInfo from "./contact/DialogLinkGroupInfo.vue";
import moment from "moment";

export default {
  props: ["searchTab"],
  components: {
    TagV2,
    IconV2,
    DialogSearchContact,
    DialogSearchGroupByLink,
    DialogLinkGroupInfo,
  },
  data() {
    return {
      inputSearchKey: "",
      selectAccountId: [],
      selectAllAccount: false,
      accounts: [],
      accountsFilter: [],
      accountSearch: "",
      filter: {
        searchKey: "",
        selectedAccountIds: [],
        lastMessageTime: 0,
        selectedTags: [],
        dateRange: [],
        filterMessage: "",
        filterGroup: null,
        unReplied: null,
      },

      searchNewContactVisible: false,
      dialogSearchGroup: false,
      dialogLinkGroupInfo: false,
      dataLinkGroupInfo: {
        link: "",
        conversation: {},
      },

      filterMessage: {
        searchKey: "",
        conversationType: "all",
        dateRange: [],
        dateRangeValue: "",
      },
      searchTag: "",
    };
  },
  computed: {
    filterMessages() {
      return [
        {
          text: "Chưa đọc",
          src: "v2-unread",
          key: "UNREAD",
        },
        { text: "Chưa trả lời", src: "v2-no_reply", key: "UNREPLIED" },
      ];
    },
    filterGroups() {
      return [
        { text: "Cá nhân", src: "v2-user", key: "INDIVIDUAL" },
        {
          text: "Nhóm",
          src: "v2-group",
          key: "GROUP",
        },
      ];
    },
    filterEnabledTag() {
      return this.filter.selectedTags.length > 0;
    },
    filterEnableCalender() {
      if (this.filter.dateRange === null) return false;
      return this.filter.dateRange.length > 0;
    },
    filterEnabled() {
      return (
        this.filter.filterGroup !== null ||
        this.filter.filterMessage !== "" ||
        this.filter.searchKey !== "" ||
        // this.filter.selectedAccountIds.length > 0 ||
        this.filter.selectedTags.length > 0 ||
        (this.filter.dateRange != null && this.filter.dateRange.length == 2)
      );
    },
    filterDepedency() {
      return [
        this.filter.searchKey,
        this.filter.selectedAccountIds,
        // this.filter.lastMessageTime,
        this.filter.selectedTags,
        this.filter.dateRange,
        this.filter.filterMessage,
        this.filter.filterGroup,
        this.filter.unReplied,
      ];
    },
    filterMessageDepedency() {
      return [this.filterMessage.conversationType, this.filterMessage.dateRange, this.filterMessage.searchKey];
    },
    isGroup() {
      if (this.filter.filterGroup === "Nhóm") return true;
      if (this.filter.filterGroup === "Cá nhân") return false;
      return null;
    },
    filterTags() {
      if (!this.searchTag) return this.app.tags;
      return this.app.tags.filter(tag =>
        tag.name.toLowerCase().includes(this.searchTag.toLowerCase())
      );
    }
  },
  watch: {
    filterDepedency() {
      const filter = {
        isGroup: this.isGroup,
        unread: this.filter.filterMessage === "Chưa đọc",
        unReplied: this.filter.filterMessage === "Chưa trả lời" ? true : null,
        searchKey: this.filter.searchKey,
        accountIds: this.selectAccountId.length > 0 ? this.selectAccountId : [],
        selectedTags: this.filter.selectedTags,
        dateRange: this.getTimeToStamp(this.filter.dateRange),
      };
      this.$emit("onSetFilter", filter);
    },
    filterMessageDepedency() {
      const filterMessage = {
        searchKey: this.filterMessage.searchKey,
        isGroup: this.filterMessage.conversationType === "all" ? null : this.filterMessage.conversationType === "group" ? true : false,
        dateRange: this.getTimeToStamp(this.filterMessage.dateRange),
      };
      this.$emit("onSetFilterMessage", filterMessage);
    },
    selectAccountId() {
      if (this.selectAccountId.length < this.accounts.length) {
        this.selectAllAccount = false;
      } else {
        this.selectAllAccount = true;
      }
      this.removeFilter();
    },
  },

  methods: {
    onSelectAll(e) {
      e.preventDefault();
      if (!this.selectAllAccount) {
        this.selectAccountId = this.accounts.map((a) => a.accountId);
        this.selectAllAccount = true;
      } else {
        this.selectAccountId = [];
        this.selectAllAccount = false;
      }
    },
    onSelectAccount(accountId) {
      const accIndex = this.selectAccountId.findIndex((a) => a === accountId);
      if (accIndex === -1) {
        this.selectAccountId.push(accountId);
      } else {
        this.selectAccountId.splice(accIndex, 1);
      }
    },
    removeAccount() {},
    onChangeAccountSearch(name) {
      if (!name) {
        this.accountsFilter = this.accounts.map((a) => ({
          name: this.getAccountName(a),
          accountId: a.accountId,
        }));
      }
      const normalizedSearch = name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      this.accountsFilter = this.accounts
        .filter((element) => {
          const name = this.getAccountName(element);
          const normalizedElement = name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return normalizedElement.includes(normalizedSearch);
        })
        .map((a) => ({
          name: this.getAccountName(a),
          accountId: a.accountId,
        }));
    },
    getAccountList() {
      this.$http.get("/api/account").then((resp) => {
        this.accounts = resp.data;
        this.accountsFilter = this.accounts.map((a) => ({
          name: this.getAccountName(a),
          accountId: a.accountId,
        }));
      });
    },
    searchKeyChanged(e) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (this.searchTab === "contact") {
          this.filter.searchKey = e;
        } else {
          this.filterMessage.searchKey = e;
        }
      }, 700);
    },
    getTimeToStamp(dateRange) {
      let arrDate = [];
      if (dateRange.length > 0) {
        dateRange.forEach((s) => {
          arrDate.push(new Date(s).getTime());
        });
        return arrDate;
      }
      return [];
    },
    searchNewContact() {
      this.searchNewContactVisible = true;
    },
    async searchGroup() {
      this.dialogSearchGroup = true;
      this.$http.get(`/api/message/getGroupInfoByLink?accountId=${this.accounts[0].accountId}&link=${"https://zalo.me/g/ouknnq672"}`).then((resp) => {
        console.log(resp.data);
      });
    },
    selectFilterMessage(filter) {
      if (this.filter.filterMessage === filter) {
        this.filter.filterMessage = "";
      } else {
        this.filter.filterMessage = filter;
      }
    },
    selectFilterGroup(filter) {
      if (this.filter.filterGroup === filter) {
        this.filter.filterGroup = null;
      } else {
        this.filter.filterGroup = filter;
      }
    },
    selectTag(tagId) {
      let indexOf = this.filter.selectedTags.indexOf(tagId);
      if (indexOf > -1) {
        this.filter.selectedTags.splice(indexOf, 1);
      } else {
        this.filter.selectedTags.push(tagId);
      }
    },
    selectedTag(tagId) {
      let indexOf = this.filter.selectedTags.indexOf(tagId);
      if (indexOf > -1) {
        return true;
      }
      return false;
    },
    clearTag() {
      this.filter.selectedTags = [];
    },
    removeFilter() {
      this.inputSearchKey = "";
      this.filter = {
        filterMessage: "",
        searchKey: "",
        selectedAccountIds: [],
        lastMessageTime: 0,
        selectedTags: [],
        dateRange: [],
        filterGroup: null,
        unReplied: null,
      };
      this.filter.selectedAccountIds = this.selectAccountId.length > 0 ? this.selectAccountId : [];
    },
    onCloseDialogLinkGroupInfo() {
      this.dialogLinkGroupInfo = false;
      this.dataLinkGroupInfo = {
        link: "",
        conversation: {},
      };
    },
    resetFilterSearch() {
      this.$emit("updateSearchTab", "contact");
      this.filterMessage = {
        searchKey: "",
        conversationType: "all",
        dateRange: [],
        dateRangeValue: "",
      };
      this.removeFilter();
    },
    updateDateRangeValue() {
      if (!this.filterMessage.dateRange) {
        this.filterMessage.dateRange = [];
        this.filterMessage.dateRangeValue = "";
      }
      this.filterMessage.dateRangeValue =
        moment(this.filterMessage.dateRange[0]).format("DD/MM") + " - " + moment(this.filterMessage.dateRange[1]).format("DD/MM");
    },
  },
  created() {
    this.getAccountList();
  },
  mounted() {
    this.$bus.$on("clickLinkGroup", (data) => {
      this.dialogLinkGroupInfo = true;
      this.dataLinkGroupInfo = data;
    });
  },
  beforeDestroy() {
    this.$bus.$off("clickLinkGroup");
  },
};
</script>

<style lang="scss" scoped>
.account-all {
  height: 34px;
  padding-left: 20px;
}
.account-all:hover {
  background-color: #f5f7fa;
}
.account-all-active {
  color: #0a58c0;
  font-weight: bolder;
}
.btn-active {
  border: 2px solid #094fad;
  color: #094fad;
}
.btn-tab {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0px;
  background: white;
  margin-left: 0px;
}
</style>